import React from 'react';
import { useTranslation } from 'react-i18next';
import './order-form-footer.component.scss';

interface OrderFormFooterProps {
    onCancel: () => void;
    onSubmit: () => void;
    isEditMode?: boolean;
    isEmployerCertificateDraft?: boolean;
    onUpdate?: () => void;
    onSaveDraft?: () => void;
    onUpdateDraft?: () => void;
    disabled?: boolean;
    isSavingDraft?: boolean;
    isUpdatingDraft?: boolean;
}

export const OrderFormFooter: React.FC<OrderFormFooterProps> = ({
    onCancel,
    onSubmit,
    isEditMode = false,
    isEmployerCertificateDraft = false,
    onUpdate,
    onSaveDraft,
    onUpdateDraft,
    disabled = false,
    isSavingDraft = false,
    isUpdatingDraft = false,
}) => {
    const { t } = useTranslation();

    return (
        <div className="order-form-footer">
            <button 
                type="button"
                className="order-form-footer__cancel"
                onClick={onCancel}
            >
                {t('Cancel')}
            </button>
            
            {isEmployerCertificateDraft ? (
                onUpdateDraft && (
                    <button 
                        type="button"
                        className="order-form-footer__draft"
                        onClick={onUpdateDraft}
                        disabled={isUpdatingDraft}
                    >
                        {isUpdatingDraft ? t('Saving...') : t('Update Draft')}
                    </button>
                )
            ) : (
                onSaveDraft && !isEditMode && (
                    <button 
                        type="button"
                        className="order-form-footer__draft"
                        onClick={onSaveDraft}
                        disabled={isSavingDraft}
                    >
                        {isSavingDraft ? t('Saving...') : t('Save Draft')}
                    </button>
                )
            )}
            
            {isEditMode && !isEmployerCertificateDraft ? (
                <button 
                    type="button"
                    className="order-form-footer__submit"
                    onClick={onUpdate}
                    disabled={disabled}
                >
                    {t('Update')}
                </button>
            ) : (
                <button 
                    type="button"
                    className="order-form-footer__submit"
                    onClick={onSubmit}
                    disabled={disabled}
                >
                    {t('Submitemployercertifcate')}
                </button>
            )}
        </div>
    );
};
